import { useQuery } from '@apollo/client';
import GET_LOCAL_USER from 'graphql/getLocalUser';

export default function useLocalUser() {
  const { loading, data } = useQuery(GET_LOCAL_USER);
  return [loading, data?.localUser];
}
